import { Component, OnInit } from '@angular/core';
import { ApiProcesosService } from '../../shared/services/api-procesos.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AppStorage } from '../../shared/services/appStorage.service';
import { ModalProcesoComponent } from './modal-proceso/modal-proceso.component';

@Component({
  selector: 'app-procesos',
  templateUrl: './procesos.component.html',
  styleUrls: ['./procesos.component.css']
})
export class ProcesosComponent implements OnInit {
  // data
  dataSource;

  // loading
  loadingProcesos;

  displayedColumns: string[] = ['nombre', 'sigla', 'estado', 'idProceso'];

  constructor(
    private apiService: ApiProcesosService,
    public dialog: MatDialog,
    public appStorage: AppStorage,
    private router: Router
  ) {}

  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      this.appStorage.goHome();
    } else {
      this.getProcesos();
    }
  }

  openModalProceso(proceso) {
    const procesoAux = proceso
      ? JSON.parse(JSON.stringify(proceso))
      : undefined;

    const dialogRef = this.dialog.open(ModalProcesoComponent, {
      width: '550px',
      data: {
        proceso: procesoAux
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getProcesos();
      }
    });

    return dialogRef;
  }

  getProcesos() {
    this.loadingProcesos = true;
    this.apiService.getProcesos().then((data: Array<object>) => {
      this.dataSource = data;
      this.loadingProcesos = false;
    });

    // setTimeout(() => {
    //   this.dataSource = [{ nombre: 'Proceso 1', sigla: 'ASD1', idProceso: 1 }, { nombre: 'Proceso 2', sigla: 'ASD1', idProceso: 1 }];
    //   this.loadingProcesos = false;
    // }, 1000);
  }
}
